import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { IWaitingRoomMember } from '@gem/call/Model/callModel.types';

interface IWaitingRoomListPresenter {
  call: Call;
  members: IWaitingRoomMember[];
  keyExtractor(member: IWaitingRoomMember): string;
}

export const useWaitingRoomListPresenter = (): IWaitingRoomListPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IWaitingRoomListPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get members(): IWaitingRoomMember[] {
      return (presenter.call.waitingRoom.requestedMembersArray || []) as IWaitingRoomMember[];
    },

    keyExtractor(member: IWaitingRoomMember): string {
      return member?.memberId;
    },
  }));

  return presenter;
};
